//Auth Actions
export const addAuthState = (store, authState) => {
  store.setState(authState);
};
export const addAuthClaims = (store, authClaims) => {
  if (authClaims) {
    const list = new Set();
    authClaims.forEach((el) => {
      list.add(el.ops.id);
    });
    store.setState({ authClaims, opsList: [...list] });
  }
};
export const selectTab = (store, key) => {
  store.setState({ permissionsTab: { key } });
};
//New PO Actions
export * from "./PoStore";
